import { render, staticRenderFns } from "./ActionNoti.vue?vue&type=template&id=25188d12&scoped=true"
import script from "./ActionNoti.vue?vue&type=script&lang=js"
export * from "./ActionNoti.vue?vue&type=script&lang=js"
import style0 from "./ActionNoti.vue?vue&type=style&index=0&id=25188d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25188d12",
  null
  
)

export default component.exports